import styled from "styled-components";
import { theme } from "./mui-config";
import { Button, Grid, IconButton, Stack } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

export const StyledGlStack = styled(Stack)`
  background-color: ${theme.palette.secondary.light};
  border-radius: 4px;
  box-shadow: 0 0 5px ${theme.palette.shadow.main};
  margin-top: 30px;
  width: 100%;
  padding: 20px;
  padding-top: 15px;
`;

export const StyledGlTitle = styled.div`
  width: 100%;
  padding: 10px;
  padding-bottom: 20px;
  border-bottom: 2px solid ${theme.palette.primary.main};
  margin-bottom: 20px;
  font-family: IRANSans;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.6;
  color: ${props => props.color ? theme.palette[props.color].main : "gray"};
`;

export const StyledIconButton = styled(IconButton)`
  margin: 0px !important;
  padding: 5px !important;
  & svg {
    color: ${(props) =>
      props.color
        ? theme.palette[props.color].main
        : theme.palette.primary.main};
  }
`;

export const StyledGridIcons = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  & button {
    box-shadow: -2px -2px 15px #dbdbdb, 2px 2px 15px #cacaca;
    margin: 0px 10px;
    padding: 5px;
    & svg {
      border: none !important;
      border-radius: 100%;
      box-shadow: none !important;
      @media (max-width: 700px) {
        font-size: 24px;
      }
    }
    @media (max-width: 700px) {
      margin: 0px 5px;
    }
    @media (max-width: 599px) {
      margin: 10px 8px 0px;
    }
  }
  & :hover {
    box-shadow: inset -2px -2px 5px #dbdbdb, inset 2px 2px 5px #cacaca;
    & button {
      & svg {
        box-shadow: none;
      }
    }
  }
  @media (max-width: 600px) {
    justify-content: left;
  }
`;

export const ButtonContainer = styled.div`
  width: max-content;
  float: right;
  padding: 10px;
  text-align: left;
`;

export const StyledGlDateBox = styled.div`
  width: 100% !important;
  & .rmdp-container {
    width: 100% !important;
  }
`;

export const StyledGlBtn = (props) => {
  return (
    <Grid item lg={12} sx={{ display: "flex", justifyContent: "end" }}>
      <ButtonContainer>
        <Button
          startIcon={
            props.icon ? props.icon : props.icon === false ? "" : <CheckIcon />
          }
          color={props.color || "primary"}
          variant={props.type || "contained"}
          sx={{ mt: 1, mx: 0.5 }}
          onClick={props.onClick}
        >
          {props.title || "ذخیره"}
        </Button>
      </ButtonContainer>
    </Grid>
  );
};
